/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayPauseIcon16Light = forwardRef('MediaUiAPlayPauseIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M12.5 2a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-1 0v-11a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 3.18a1.15 1.15 0 0 1 1.764-.973l7.7 4.863a1.1 1.1 0 0 1 0 1.86l-7.7 4.863A1.15 1.15 0 0 1 0 12.821V3.179Zm1.23-.128A.15.15 0 0 0 1 3.18v9.642c0 .118.13.19.23.127l7.7-4.863a.1.1 0 0 0 0-.17l-7.7-4.863Z" }),
        React.createElement("path", { d: "M16 2.5a.5.5 0 0 0-1 0v11a.5.5 0 0 0 1 0v-11Z" })));
});
